module.exports = __webpack_public_path__ + "img/nodata-share-printing@3x.124050cb.png";